import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

import {
  addWorkDairyAction,
  checkWorkDiaryBookingDayAction,
  deleteTaskAction,
  getCompleteWorkDiaryAction,
  getEmailPdfTaskAction,
  getJobListAction,
  getJobOptimiseAction,
  getWorkDiaryAction,
  getWorkDiaryTypeOptionsAction,
  jobPrintAction,
  setCompleteWorkDiaryAction,
  setCompleteWorkDiaryLoading,
  setDeleteTaskResponseAction,
  setEmailPdfTaskResponseAction,
  setJobListAction,
  setJobOptimiseAction,
  setJobPrintAction,
  setResponseCheckWorkDiaryBookingDayAction,
  setUpdateWorkDiaryBookingStatusAction,
  setUpdateWorkDiaryResponseAction,
  setWorkDiaryAction,
  setWorkDiaryResponseAction,
  setWorkDiaryTypeOptionsAction,
  updateWorkDairyAction,
  updateWorkDiaryBookingStatusAction,
} from "../reducers/workDiarySlice";
import JsFileDownloader from "js-file-downloader";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getWorkDiarySaga(action: any): any {
  const { startDate, endDate } = action.payload;
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/tasks?startDate=${startDate}&endDate=${endDate}`);
    console.log("plans-", res);
    if (res?.data) {
      yield put(setWorkDiaryAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getCompleteWorkDiarySaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setCompleteWorkDiaryLoading(true));
  const { search, startDateRange, endDateRange, taskType, leadId, actionType } =
    action.payload;
  console.log("plans-try");
  try {
    // Build query string dynamically
    const params = [];
    // if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (startDateRange)
      params.push(`startDateRange=${encodeURIComponent(startDateRange)}`);
    if (endDateRange)
      params.push(`endDateRange=${encodeURIComponent(endDateRange)}`);
    if (actionType) params.push(`action=${encodeURIComponent(actionType)}`);
    if (taskType) params.push(`taskType=${encodeURIComponent(taskType)}`);
    if (leadId) params.push(`leadId=${encodeURIComponent(leadId)}`);
    const queryString = params.length ? `&${params.join("&")}` : "";
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/job-list?search=${encodeURIComponent(search)}${queryString}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setCompleteWorkDiaryAction(res?.data));
       yield put(setCompleteWorkDiaryLoading(false));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setCompleteWorkDiaryLoading(false));
  yield put(setLoaderAction(false));
}

function* getJobListSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/jobs`);
    console.log("plans-", res);
    if (res?.data) {
      yield put(setJobListAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addWorkDairySaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/tasks",
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setWorkDiaryResponseAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setWorkDiaryResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateWorkDairySaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { task_id, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `client/tasks/${task_id}`,
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateWorkDiaryResponseAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateWorkDiaryResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getWorkDiaryTypeOptionsSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/workdiary-options`);
    console.log("plans-", res);
    if (res?.data) {
      yield put(setWorkDiaryTypeOptionsAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// Job Optimise
function* getJobOptimiseSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const { startDate, endDate, jobTypes, jobIds, radius, vanCapacity } =
      payload?.payload;
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/jobs/optimise-route?startDate=${startDate}&endDate=${endDate}&taskTypes=${jobTypes}&refJobId=${jobIds}&radius=${radius}&vanCapacity=${vanCapacity}`,
    );
    if (res?.data) {
      yield put(setJobOptimiseAction(res?.data));
    }
  } catch (error) {}
  yield put(setLoaderAction(false));
}

function* jobPrintSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `/leads/${leadId}/print-sheet-status`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setJobPrintAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setJobPrintAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateWorkDiaryBookingStatusSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload?.payload },
      "post",
      `leads/workdiary-booking`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateWorkDiaryBookingStatusAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateWorkDiaryBookingStatusAction(false));
  }
  yield put(setLoaderAction(false));
}

function* checkWorkDiaryBookingDaySaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { startDate, endDate } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/workdiary-booking?startDate=${startDate}&endDate=${endDate}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setResponseCheckWorkDiaryBookingDayAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setResponseCheckWorkDiaryBookingDayAction(false));
  }
  yield put(setLoaderAction(false));
}

// Get Email PDF Task
function* getEmailPdfTaskSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { taskId, actionType } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/tasks/${taskId}?action=${actionType}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      const fileUrl = apiResponse?.data?.pdfUrl;
      let fileUrlData = fileUrl.split("?")[0].split("/");

      new JsFileDownloader({
        url: fileUrl,
        filename: `${fileUrlData[fileUrlData.length - 1]}`,
      })
        .then(() => {
          // handleSuccess(apiResponse);

          // apiResponse && handleSuccess(apiResponse);
        })
        .catch((e) => {});
        
      yield put(setEmailPdfTaskResponseAction(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setEmailPdfTaskResponseAction(null));
  }
  yield put(setLoaderAction(false));
}

// Delete Task
function* deleteTaskSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { taskId } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/tasks/${taskId}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteTaskResponseAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteTaskResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchWorkDiary() {
  yield takeLatest<any>(getWorkDiaryAction, getWorkDiarySaga);
  yield takeLatest<any>(getCompleteWorkDiaryAction, getCompleteWorkDiarySaga);
  yield takeLatest<any>(addWorkDairyAction, addWorkDairySaga);
  yield takeLatest<any>(updateWorkDairyAction, updateWorkDairySaga);
  yield takeLatest<any>(getJobListAction, getJobListSaga);
  yield takeLatest<any>(
    getWorkDiaryTypeOptionsAction,
    getWorkDiaryTypeOptionsSaga,
  );
  yield takeLatest<any>(getJobOptimiseAction, getJobOptimiseSaga);
  yield takeLatest<any>(jobPrintAction, jobPrintSaga);
  yield takeLatest<any>(
    updateWorkDiaryBookingStatusAction,
    updateWorkDiaryBookingStatusSaga,
  );
  yield takeLatest<any>(
    checkWorkDiaryBookingDayAction,
    checkWorkDiaryBookingDaySaga,
  );
  yield takeLatest<any>(getEmailPdfTaskAction, getEmailPdfTaskSaga);
  yield takeLatest<any>(deleteTaskAction, deleteTaskSaga);
}
